<template>
  <div>
    <b-row
      class="content-header"
    >

      <!-- Content Left -->
      <b-col
        class="content-header-left mb-2"
        cols="12"
        md="12"
      >
        <b-row class="breadcrumbs-top">
          <b-col cols="12">
            <h1 class="custom-header-title">
              {{ category.stringID }} - {{ category.name }}
            </h1>
            <p class="log_info">
              Created by {{ category.createdBy ? category.createdBy.name : '' }} on {{ dateFormatWithTime(category.createdAt) }} <br>Last updated on {{ dateFormatWithTime(category.updatedAt) }}
            </p>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12">
        <b-card
          header-tag="header"
          class=""
        >
          <div class="d-flex justify-content-between">
            <b-table-simple
              borderless
              responsive
              class="custom-th-width"
            >
              <b-tbody>
                <b-tr>
                  <b-th width="230">
                    Product Category Name
                  </b-th>
                  <b-td class="mt-50">
                    {{ category.name || '-' }}
                  </b-td>
                </b-tr>
                <b-tr>
                  <b-th width="230">
                    SCLC ID
                  </b-th>
                  <b-td class="mt-50">
                    {{ category.sclcID || '-' }}
                  </b-td>
                </b-tr>
                <b-tr>
                  <b-th width="230">
                    Image
                  </b-th>
                  <b-td class="mt-50">
                    <b-img
                      v-if="category.image"
                      :src="category.image"
                      height="185"
                      width="670"
                    />
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
            <b-button
              v-if="canViewThisAction('update', 'ProductCategory')"
              variant="flat-primary"
              class="display-content"
              :to="{ name: 'products-categories-edit', params: { id: $route.params.id } }"
            >
              <feather-icon
                icon="EditIcon"
                class="mr-50"
                size="16"
              />
              <span class="align-middle">Edit</span>
            </b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BButton, BImg, BTableSimple, BTbody, BTr, BTd, BTh,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import store from '@/store/index'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import '@core/scss/vue/libs/vue-flatpicker.scss'
import { useUtils as useAclUtils } from '@/libs/acl/custom'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BTableSimple,
    BTbody,
    BTh,
    BTr,
    BTd,
    BImg,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  directives: {
    Ripple,
  },
  setup() {
    const { canViewThisAction } = useAclUtils()
    return { canViewThisAction }
  },
  data() {
    return {
      category: {},
      required,
    }
  },
  created() {
    this.$http.get(`reservation/product-category/${this.$route.params.id}`)
      .then(response => {
        this.category = response.data

        store.commit('breadcrumb/REMOVE_BREADCRUMB')
        const newMeta = {
          active: true,
          text: this.category.name,
        }
        store.commit('breadcrumb/UPDATE_BREADCRUMB', newMeta)
      })
      .catch(error => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  },
}
</script>

<style lang="scss">
  .item-field-custom-class {
    color: #000000;
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
  }
  .display-content {
    display: contents;
  }

  .custom-th-width {
    .table th {
      padding: 0.72rem 2rem 0.72rem 0.72rem;
    }
  }
</style>
